import React, { ChangeEvent, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FormWrapper from '../../../../../../Components/Form/FormWrapper';
import FormControl from '../../../../../../Components/Form/FormControl';
import FileUpload from '../../../../../../Components/Base/FileUpload/FileUpload';
import SubmitButton from '../../../../../../Components/Button/SubmitButton';
import apiClient from '../../../../../../Services/ApiClient';
import useNotification from '../../../../../../Hooks/useNotification.hook';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
import useJob from '../../../../../Base/Hooks/useJob';
import InputWrapper from '../../../../../../Components/Form/components/InputWrapper/InputWrapper';
import styles from './ManagerInsuranceCompaniesImportCaseTypes.module.scss';
import { useAppContext } from '../../../../../../Services/AppContext';

interface Props {
	onClose: () => void;
	refresh: () => void;
}

const ManagerInsuranceCompaniesImportCaseTypes: React.FC<Props> = ({
	onClose,
	refresh,
}) => {
	const [selectedFile, setSelectedFile] = useState<File>();
	const { showNotificationSuccess } = useNotification();
	const { displayError } = useApiClient();
	const { workplaceId } = useAppContext();
	const { RenderJobWaiting, handleStartWaitingForJob } = useJob();

	const validationSchema = yup.object({
		file: yup.mixed().required('File is required'),
	});

	const formMethods = useForm({ resolver: yupResolver(validationSchema) });

	const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
		const file = event.target?.files?.[0];
		if (file) {
			setSelectedFile(file);
		}
	};

	const handleSubmit = async () => {
		if (!selectedFile) {
			return;
		}

		const formData = new FormData();
		formData.append('file', selectedFile);

		const response = await apiClient.postMultipart(
			`/medical-procedure/import-workplace-medical-procedures/${workplaceId}`,
			formData,
		);

		if (
			response.status === 202 &&
			typeof response.data === 'string' &&
			response.data
		) {
			return handleStartWaitingForJob(response.data);
		}

		displayError({ response });
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<FormControl
					label='component.caseType.importFromFileSelect'
					name='file'
					onChange={handleChangeFile}
					isRequired>
					<FileUpload />
				</FormControl>
			</InputWrapper>
			<div className={styles.buttons}>
				<SubmitButton onSubmit={handleSubmit} title='base.shared.form.send' />
			</div>
			<RenderJobWaiting
				onJobSuccess={() => {
					showNotificationSuccess({
						content: 'component.caseType.importSuccess',
					});
					refresh();
					onClose();
				}}
			/>
		</FormWrapper>
	);
};

export default ManagerInsuranceCompaniesImportCaseTypes;
